import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var ManagementCompany =
/*#__PURE__*/
function (_BaseData) {
  _inherits(ManagementCompany, _BaseData);

  function ManagementCompany() {
    _classCallCheck(this, ManagementCompany);

    return _possibleConstructorReturn(this, _getPrototypeOf(ManagementCompany).call(this, "ManagementCompany"));
  }

  _createClass(ManagementCompany, [{
    key: "GetManagementCompanyInfoByUserId",
    value: function GetManagementCompanyInfoByUserId(userId) {
      return axios.get("api/".concat(this._controller, "/GetManagementCompanyInfoByUserId"), {
        params: {
          userId: userId
        }
      });
    }
  }, {
    key: "GetManagementCompanyInfoByProjectId",
    value: function GetManagementCompanyInfoByProjectId(projectId) {
      return axios.get("api/".concat(this._controller, "/GetManagementCompanyInfoByProjectId"), {
        params: {
          projectId: projectId
        }
      });
    }
  }, {
    key: "MergeManagementCompanies",
    value: function MergeManagementCompanies(fromIds, toId) {
      return axios.post("api/".concat(this._controller, "/MergeManagementCompanies/").concat(toId), fromIds);
    }
  }, {
    key: "GetWithPropertyCount",
    value: function GetWithPropertyCount() {
      return axios.get("api/".concat(this._controller, "/GetWithPropertyCount"));
    }
  }, {
    key: "GetDefaultQuarter",
    value: function GetDefaultQuarter() {
      return axios.get("api/".concat(this._controller, "/GetDefaultQuarter"));
    }
  }, {
    key: "GetCertifiedManagementCompanies",
    value: function GetCertifiedManagementCompanies() {
      return axios.get("api/".concat(this._controller, "/GetCertifiedManagementCompanies"));
    }
  }, {
    key: "GetProjectsByManagementCompanyId",
    value: function GetProjectsByManagementCompanyId(managementCompanyId) {
      return axios.get("/api/".concat(this._controller, "/GetProjectsByManagementCompanyId/").concat(managementCompanyId));
    }
  }]);

  return ManagementCompany;
}(BaseData);

export default new ManagementCompany();